import { render, staticRenderFns } from "./OtherPropertyInsuranceNote.vue?vue&type=template&id=49c74851"
import script from "./OtherPropertyInsuranceNote.vue?vue&type=script&lang=js"
export * from "./OtherPropertyInsuranceNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports